import mountVueOnPage from '../mount_vue'

// The full (filtered) group list is fetched in one request; we only paint a
// slice of it, revealing more as a bottom sentinel scrolls into view.
const REVEAL_STEP = 48

mountVueOnPage('groups', 'index', {
    data() {
        return {
            groups: [],
            search: '',
            filter: 'all',
            category: '',
            visibleCount: REVEAL_STEP,
            observer: null,
            loadTimer: null,
            ready: false, // false until the first fetch resolves — drives the content spinner
        }
    },
    computed: {
        visibleGroups() {
            return this.groups.slice(0, this.visibleCount)
        },
    },
    async created() {
        await this.update();
        this.ready = true;
    },
    mounted() {
        this.observer = new IntersectionObserver(
            (entries) => {
                if (!entries[0].isIntersecting) return
                clearTimeout(this.loadTimer)
                this.loadTimer = setTimeout(() => this.revealMore(), 200)
            },
            { rootMargin: '120px' },
        )
        if (this.$refs.sentinel) this.observer.observe(this.$refs.sentinel)
    },
    unmounted() {
        if (this.observer) this.observer.disconnect()
    },
    methods: {
        revealMore() {
            if (this.visibleCount < this.groups.length) this.visibleCount += REVEAL_STEP
        },
        async update() {
            const posts = await axios.get('/groups.json', {
                params: {
                    search: this.search,
                    filter: this.filter,
                    category: this.category,
                },
            })
            if (posts.data) {
                this.groups = posts.data;
                this.visibleCount = REVEAL_STEP; // reset the slice when the result set changes
            }
        },
    },
    watch: {
        async filter() {
            await this.update();
        },
        async category() {
            await this.update();
        }
    }
})
